import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

/**
 * The tenant-facing counterpart to the raw catalog index. `/catalog` answers
 * "what entities exist on this platform", which is an operator question and is
 * gated behind the platform-admin permission in the sidebar. This page answers
 * the only question most users have - "what did I provision, and is it up" -
 * so it is the one that stays in everyone's navigation.
 */
const myStacksPage = PageBlueprint.make({
  name: 'my-stacks',
  params: {
    path: '/my-stacks',
    noHeader: true,
    loader: () => import('./MyStacksPage').then(m => <m.MyStacksPage />),
  },
});

export const stacksModule = createFrontendModule({
  pluginId: 'app',
  extensions: [myStacksPage],
});
